import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

const markOwner = (u) => {
  localStorage.setItem("esc_owner", "1");
  return u;
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(markOwner(r.data)))
      .catch(() => api.post("/auth/refresh").then((r) => setUser(markOwner(r.data))).catch(() => setUser(false)));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(markOwner(data));
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center text-moss" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
